import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DynamicBanner from "../../include/DynamicBanner";
import StickyNav from "../CommitteeCouncil/Partials/StickyNav"; // Reusing StickyNav if needed
import api from "../../../../api";
import "./Nisp.css";

const Nisp = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. Fetch Data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/nisp");
        if (response.data.status) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching NISP data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 2. Loading State
  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!data) return <div className="text-center py-5">No Data Found</div>;

  const bannerImage =
    data.banner_section?.desktop_images?.length > 0
      ? data.banner_section.desktop_images.map((img) => `/${img}`)
      : ["/assets/images/default-banner.webp"];

  const bannerImageMobile =
    data.banner_section?.mobile_images?.length > 0
      ? data.banner_section.mobile_images.map((img) => `/${img}`)
      : ["/assets/images/default-banner.webp"];

  const bannerTitle = data.banner_section?.heading || "NISP";

  // 4. Prepare PDF List
  const pdfItems = data.pdf_section?.pdfs || [];
  const pdfSectionHeading = data.pdf_section?.heading || "NISP";

  return (
    <>
      <DynamicBanner
        title={bannerTitle}
        bgImage={bannerImage}
        bgImageMobile={bannerImageMobile}
      />
      <StickyNav tabs={data.introduction_tabs} />
      {/* Sticky Nav (Optional - keeping it consistent with your other pages) */}
      {/* <StickyNav />  <-- Uncomment if you have a specific nav for NISP */}

      <section className="nisp-page pb_80 mt-5">
        <div className="container">
          {/* Section Heading */}
          <div className="sec-title text-center mb-5">
            <h2>{pdfSectionHeading}</h2>
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            {pdfItems.length > 0 ? (
              pdfItems.map((item, index) => {
                // Construct PDF Link
                // If it starts with http, it's external. Otherwise, append Base URL.
                const isExternal = item.url.startsWith("http");
                const pdfLink = isExternal
                  ? item.url
                  : `${process.env.REACT_APP_API_URL}/public${item.url}`;

                return (
                  <div className="col-md-4 col-12 mb-4" key={index}>
                    <div className="card h-100 shadow-sm border-0 nisp-card">
                      <Link
                        to={pdfLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none text-dark d-flex align-items-center p-3"
                      >
                        {/* PDF Icon / Thumbnail */}
                        <div className="pdf-icon-wrapper me-3">
                          <img
                            src="/assets/images/pdf.webp" // Keeping static icon for consistency
                            alt="PDF"
                            className="img-fluid"
                            style={{ width: "60px", height: "auto" }}
                          />
                        </div>

                        {/* PDF Title */}
                        <div className="pdf-content">
                          <h2
                            style={{
                              fontSize: "13px",
                              color: "black",
                              margin: 0,
                            }}
                          >
                            {item.name}
                          </h2>

                          <small
                            style={{
                              fontSize: "11px",
                              color: "#6c757d",
                            }}
                          >
                            Click to view
                          </small>
                        </div>
                      </Link>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12 text-center">
                <p>No documents currently available.</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Nisp;
